(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function makeMoney(format) {
    format = format || '\x7b\x7bamount_with_space_separator\x7d\x7d kr';
    return function (cents) {
      var n = cents / 100;
      function f(dec, th, de) {
        var p = n.toFixed(dec).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return p.join(de);
      }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_with_space_separator') return f(2, ' ', ',');
        if (k === 'amount_no_decimals_with_space_separator') return f(0, ' ', ',');
        if (k === 'amount_with_comma_separator') return f(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
        if (k === 'amount_with_apostrophe_separator') return f(2, "'", '.');
        if (k === 'amount_no_decimals') return f(0, ',', '.');
        return f(2, ',', '.');
      }).replace(/ kr$/, ' kr');
    };
  }

  function rid() { var c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', s = ''; for (var i = 0; i < 4; i++) s += c[Math.floor(Math.random() * c.length)]; return s; }

  function init(el) {
    if (el.hasAttribute('data-kkb-init')) return;
    el.setAttribute('data-kkb-init', '');
    var dataEl = el.querySelector('script[data-kkb-data]');
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var T = D.t;
    var money = makeMoney(D.mf);
    // Whole kroner without ",00" for the short hints (price per piece, +X kr, Spar ekstra X kr).
    var kr = function (c) { return money(Math.round(c / 100) * 100).replace(/[,.]00(?=\s*kr$)/, ''); };
    var mix = D.mode === 'mix';
    var P = D.products;

    // Each product only offers the option values its allowed variants use; an option with one value is not shown.
    // Colour options are tapped swatches, short option lists are pills (both start on a value),
    // long lists are dropdowns that start empty and must be chosen.
    P.forEach(function (p) {
      p.opts = p.options.map(function (o, i) {
        var used = {};
        p.variants.forEach(function (v) { used[v.o[i]] = true; });
        var vals = o.values.filter(function (v) { return used[v.name]; });
        var sw = vals.some(function (v) { return !!v.swatch; });
        var longest = vals.reduce(function (m, v) { return Math.max(m, v.name.length); }, 0);
        var kind = vals.length <= 1 ? 'hide' : sw ? 'sw' : (vals.length <= 4 && longest <= 16 ? 'pill' : 'sel');
        return { name: o.name, values: vals, kind: kind };
      });
      p.vimg = p.variants.some(function (v) { return !!v.img; });
      p.min = Math.min.apply(null, p.variants.map(function (v) { return v.p; }));
      p.max = Math.max.apply(null, p.variants.map(function (v) { return v.p; }));
    });
    var addons = mix ? P.map(function (_, i) { return i; }) : [0];

    function startVals(p, from) {
      var base = (from && from.p === P.indexOf(p) && from.vals) || null;
      var sel = p.variants.filter(function (v) { return v.id === p.sel && v.a; })[0] || p.variants.filter(function (v) { return v.a; })[0] || p.variants[0];
      return p.opts.map(function (o, i) {
        if (o.kind === 'sel') return null;
        if (base) return base[i];
        return sel.o[i];
      });
    }
    function newSlot(i) {
      if (i === 0 || !mix) {
        var prev = state.slots[state.slots.length - 1];
        return { p: 0, vals: startVals(P[0], i === 0 ? null : prev) };
      }
      // Pre-picked add-on for this slot (D.preset, by product handle), when it is in the list.
      var h = D.preset && D.preset[i - 1], pi = -1;
      if (h) P.forEach(function (p, k) { if (k > 0 && pi < 0 && p.h === h) pi = k; });
      return pi > 0 ? { p: pi, vals: startVals(P[pi]) } : { p: null, vals: [] };
    }

    var state = { tier: D.start || 0, slots: [] };
    function syncSlots() {
      var q = D.tiers[state.tier].qty;
      while (state.slots.length < q) state.slots.push(newSlot(state.slots.length));
      state.slots.length = q;
    }

    function matches(v, vals) {
      for (var j = 0; j < vals.length; j++) if (vals[j] != null && v.o[j] !== vals[j]) return false;
      return true;
    }
    function variantOf(slot) {
      if (slot.p == null) return null;
      var p = P[slot.p];
      for (var j = 0; j < p.opts.length; j++) if (p.opts[j].kind !== 'hide' && slot.vals[j] == null) return null;
      var hit = p.variants.filter(function (v) {
        for (var j = 0; j < p.opts.length; j++) if (p.opts[j].kind !== 'hide' && v.o[j] !== slot.vals[j]) return false;
        return true;
      });
      return hit[0] || null;
    }
    // Photo of the chosen variant (or of the first variant that fits the choices made so far).
    function variantImg(p, vals) {
      var hit = p.variants.filter(function (v) { return v.img && matches(v, vals || []); });
      return hit.length ? hit[0].img : p.img;
    }
    function variantMedia(p, vals) {
      var hit = p.variants.filter(function (v) { return v.m && matches(v, vals || []); });
      return hit.length ? hit[0].m : 0;
    }
    // Show the chosen variant's photo in the product gallery too, when that photo is part of the gallery.
    function syncGallery(slot) {
      if (!slot || slot.p !== 0) return;
      var m = variantMedia(P[0], slot.vals);
      if (!m) return;
      var slide = document.querySelector('.product__media-list [data-media-id$="-' + m + '"]');
      var gallery = slide && slide.closest('media-gallery');
      if (!gallery || !slide.getClientRects().length || typeof gallery.setActiveMedia !== 'function') return;
      try { gallery.setActiveMedia(slide.getAttribute('data-media-id'), false); } catch (err) {}
    }
    function canPick(p, vals, idx, value) {
      var probe = vals.slice(); probe[idx] = value;
      return p.variants.some(function (v) { return v.a && matches(v, probe); });
    }
    // Lowest and highest unit price a slot can still end up at.
    function slotRange(slot) {
      if (!slot || slot.p == null) {
        return addons.reduce(function (r, i) { return [Math.min(r[0], P[i].min), Math.max(r[1], P[i].max)]; }, [Infinity, 0]);
      }
      var p = P[slot.p];
      var hit = p.variants.filter(function (v) { return matches(v, slot.vals); });
      if (!hit.length) hit = p.variants;
      var ps = hit.map(function (v) { return v.p; });
      return [Math.min.apply(null, ps), Math.max.apply(null, ps)];
    }
    function tierPrice(ti) {
      var t = D.tiers[ti], lo = 0, hi = 0;
      for (var i = 0; i < t.qty; i++) {
        var slot = state.slots[i] || (mix && i > 0 ? null : { p: 0, vals: state.slots[0] ? state.slots[0].vals : startVals(P[0]) });
        var r = slotRange(slot);
        lo += r[0]; hi += r[1];
      }
      var k = (100 - t.off) / 100;
      return { now: Math.round(lo * k), reg: lo, varies: lo !== hi };
    }

    // ---- markup -------------------------------------------------------------
    var html = '<p class="kkb__title">' + esc(D.title || T.title) + '</p><div class="kkb__tiers">';
    D.tiers.forEach(function (t, i) {
      var name = t.name || (t.qty + ' ' + D.unit);
      html += '<div class="kkb-tier" data-i="' + i + '">' +
        (t.badge ? '<span class="kkb-tier__badge">' + esc(t.badge) + '</span>' : t.off > 0 && !D.extra ? '<span class="kkb-tier__badge">' + esc(T.save) + ' ' + t.off + ' %</span>' : '') +
        '<button type="button" class="kkb-tier__head" aria-pressed="false">' +
          '<span class="kkb-tier__radio" aria-hidden="true"></span>' +
          '<span class="kkb-tier__main"><span class="kkb-tier__name">' + esc(name) + '</span>' + (D.extra && t.off > 0 ? '<span class="kkb-tier__extra"></span>' : '') + '<span class="kkb-tier__sub"></span></span>' +
          '<span class="kkb-tier__price"><span class="kkb-tier__now"></span><span class="kkb-tier__was"></span></span>' +
        '</button></div>';
    });
    html += '</div><button type="button" class="kkb-atc"></button><p class="kkb-msg" role="alert"></p>';
    var mount = el.querySelector('[data-kkb-mount]');
    mount.innerHTML = html;
    var tierEls = mount.querySelectorAll('.kkb-tier');
    var atc = mount.querySelector('.kkb-atc');
    var msg = mount.querySelector('.kkb-msg');
    // Shipping line (snippets/kk-delivery.liquid, position 'bundle') goes just above the button.
    var shipLine = (el.closest('.product__info-container') || document).querySelector('[data-kkb-ship]');
    if (shipLine) mount.insertBefore(shipLine, atc);

    function renderPrices() {
      D.tiers.forEach(function (t, i) {
        var te = tierEls[i], pr = tierPrice(i);
        var sub = t.sub ? esc(t.sub) : (t.qty > 1 ? money(Math.round(pr.now / t.qty)) + ' per ' + esc(D.unit) : esc(T.single));
        if (D.free > 0 && pr.now >= D.free) sub += ' · <b>' + esc(T.free) + '</b>';
        te.querySelector('.kkb-tier__sub').innerHTML = sub;
        te.querySelector('.kkb-tier__now').textContent = (pr.varies ? T.from + ' ' : '') + money(pr.now);
        te.querySelector('.kkb-tier__was').textContent = pr.now < pr.reg ? money(pr.reg) : '';
        // "Spar ekstra X kr": the bundle saving in kroner, on top of the sale price (D.extra).
        var ex = te.querySelector('.kkb-tier__extra');
        if (ex) ex.textContent = pr.now < pr.reg ? T.extraSave + ' ' + kr(pr.reg - pr.now) : '';
      });
    }

    function slotLabel(si) {
      var t = D.tiers[state.tier];
      if (mix) return si === 0 ? D.main : T.extra.replace('{n}', si);
      return t.qty > 1 ? (D.slot || T.slot).replace('{n}', si + 1) : (D.yours || T.yours);
    }
    function slotSummary(slot) {
      if (slot.p == null) return '';
      var p = P[slot.p], bits = [];
      if (mix && slot.p !== 0) bits.push(p.short);
      if (mix && slot.p === 0 && state.slots.indexOf(slot) > 0) bits.push(D.again);
      p.opts.forEach(function (o, i) { if (o.kind !== 'hide' && slot.vals[i] != null) bits.push(slot.vals[i]); });
      return bits.join(' · ');
    }

    // Hints on the pills of one option: the price per piece for pack sizes ("3 stk …") or "+X kr" when the choice
    // costs more, only when the values really differ in price; plus the "Mest populær" tag on the main product.
    function pillTags(p, slot, oi, o) {
      var out = {}, prices = {}, list = [];
      o.values.forEach(function (v) {
        var probe = slot.vals.slice(); probe[oi] = v.name;
        var hit = p.variants.filter(function (x) { return matches(x, probe); });
        if (hit.length) { prices[v.name] = Math.min.apply(null, hit.map(function (x) { return x.p; })); list.push(prices[v.name]); }
      });
      var min = Math.min.apply(null, list), max = Math.max.apply(null, list);
      o.values.forEach(function (v) {
        var t = {}, pr = prices[v.name];
        if (slot.p === 0 && D.popular && D.popular === v.name) t.pop = true;
        if (pr != null && max > min) {
          var m = /^(\d+)\s*stk\b/i.exec(v.name);
          if (m && Number(m[1]) > 1) t.sub = kr(pr / Number(m[1])) + '/stk';
          else if (pr > min) t.sub = '+' + kr(pr - min);
        }
        out[v.name] = t;
      });
      return out;
    }

    function optsHtml(slot, si) {
      var p = P[slot.p], h = '', row = '', swRows = '';
      // Swatches and a dropdown share one row when there are only a few colours; with many colours they get a row each.
      var inline = p.opts.every(function (x) { return x.kind !== 'sw' || x.values.length <= 5; });
      p.opts.forEach(function (o, oi) {
        if (o.kind === 'hide') return;
        var lab = esc(o.name + ' – ' + slotLabel(si));
        if (o.kind === 'sw') {
          var sw = '<div class="kkb-sw' + (inline ? '' : ' kkb-sw--wrap') + '" role="group" aria-label="' + lab + '">';
          o.values.forEach(function (v) {
            var can = canPick(p, slot.vals.map(function (x, k) { return p.opts[k].kind === 'sw' ? null : x; }), oi, v.name);
            sw += '<button type="button" class="kkb-sw__b" data-o="' + oi + '" data-v="' + esc(v.name) + '" style="--sw:' + esc(v.swatch || '#ccc') + '" aria-pressed="' + (slot.vals[oi] === v.name) + '" aria-label="' + esc(v.name) + '" title="' + esc(v.name) + '"' + (can ? '' : ' disabled') + '></button>';
          });
          sw += '</div>';
          if (inline) row += sw; else swRows += sw;
        } else if (o.kind === 'pill') {
          var tags = pillTags(p, slot, oi, o);
          h += '<div class="kkb-pills" role="group" aria-label="' + lab + '">';
          o.values.forEach(function (v) {
            var can = canPick(p, slot.vals, oi, v.name), tg = tags[v.name] || {};
            h += '<button type="button" class="kkb-pill' + (tg.sub ? ' kkb-pill--sub' : '') + '" data-o="' + oi + '" data-v="' + esc(v.name) + '" aria-pressed="' + (slot.vals[oi] === v.name) + '"' + (can ? '' : ' disabled') + '>' +
              (tg.pop ? '<span class="kkb-pill__pop">' + esc(T.popular) + '</span>' : '') + esc(v.name) +
              (tg.sub ? '<small class="kkb-pill__sub">' + esc(tg.sub) + '</small>' : '') + '</button>';
          });
          h += '</div>';
          if (slot.p === 0 && D.note && D.note_for === slot.vals[oi]) h += '<p class="kkb-note">' + esc(D.note) + '</p>';
        } else {
          var hasSw = inline && p.opts.some(function (x) { return x.kind === 'sw'; });
          var sel = '<label class="kkb-sel' + (hasSw ? '' : ' kkb-sel--wide') + '"><select data-o="' + oi + '" class="' + (slot.vals[oi] == null ? 'is-empty' : '') + '" aria-label="' + lab + '"><option value=""' + (slot.vals[oi] == null ? ' selected' : '') + ' disabled>' + esc(hasSw ? o.name : T.choose.replace('{o}', o.name.toLowerCase())) + '</option>';
          o.values.forEach(function (v) {
            var can = canPick(p, slot.vals, oi, v.name);
            sel += '<option value="' + esc(v.name) + '"' + (slot.vals[oi] === v.name ? ' selected' : '') + (can ? '' : ' disabled') + '>' + esc(v.name) + (can ? '' : ' – ' + esc(T.soldout)) + '</option>';
          });
          sel += '</select></label>';
          if (hasSw) row += sel; else h += '<div class="kkb-slot__row">' + sel + '</div>';
        }
      });
      if (row) h = '<div class="kkb-slot__row">' + row + '</div>' + h;
      h = swRows + h;
      return h ? '<div class="kkb-slot__opts">' + h + '</div>' : '';
    }

    function pickHtml(slot, si) {
      var h = '<div class="kkb-pick" role="group" aria-label="' + esc(T.pick + ' – ' + slotLabel(si)) + '">';
      addons.forEach(function (i) {
        var p = P[i];
        var k = (100 - D.tiers[state.tier].off) / 100;
        var now = Math.round(p.min * k);
        var price = '<span class="kkb-card__now">' + (p.min === p.max ? '' : T.from + ' ') + money(now) + '</span>' + (now < p.min ? '<s class="kkb-card__was">' + money(p.min) + '</s>' : '');
        var img = slot.p === i ? variantImg(p, slot.vals) : p.img;
        h += '<button type="button" class="kkb-card" data-p="' + i + '" aria-pressed="' + (slot.p === i) + '">' +
          '<span class="kkb-card__tick">' + TICK + '</span>' +
          (img ? '<img class="kkb-card__img" src="' + esc(img) + '" alt=""' + (slot.p === i ? '' : ' loading="lazy"') + ' width="200" height="200">' : '<span class="kkb-card__img"></span>') +
          '<span class="kkb-card__name">' + esc(i === 0 ? D.again : p.short) + '</span>' +
          '<span class="kkb-card__price">' + price + '</span></button>';
      });
      return h + '</div>';
    }

    function slotHtml(slot, si) {
      var thumb = !(mix && si > 0) && slot.p != null && P[slot.p].vimg;
      var h = '<div class="kkb-slot' + (thumb ? ' kkb-slot--media' : '') + '" data-s="' + si + '">';
      if (thumb) h += '<img class="kkb-slot__img" src="' + esc(variantImg(P[slot.p], slot.vals)) + '" alt="" width="200" height="200"><div class="kkb-slot__main">';
      h += '<div class="kkb-slot__top"><span class="kkb-slot__n">' + esc(slotLabel(si)) + '</span><span class="kkb-slot__val">' + esc(slotSummary(slot)) + '</span></div>';
      if (mix && si > 0) h += pickHtml(slot, si);
      if (slot.p != null) h += optsHtml(slot, si);
      return h + (thumb ? '</div>' : '') + '</div>';
    }

    // Keep the chosen add-on card fully in view inside its scroll row.
    function showPicked(row) {
      var c = row.querySelector('.kkb-card[aria-pressed="true"]');
      if (!c) return;
      var l = c.offsetLeft - row.offsetLeft, r = l + c.offsetWidth;
      if (l < row.scrollLeft + 8) row.scrollLeft = Math.max(0, l - 16);
      else if (r > row.scrollLeft + row.clientWidth - 8) row.scrollLeft = r - row.clientWidth + 16;
    }

    function renderSlot(si) {
      var old = mount.querySelector('.kkb-slot[data-s="' + si + '"]');
      if (!old) return;
      var pick = old.querySelector('.kkb-pick'), scroll = pick ? pick.scrollLeft : 0;
      var tmp = document.createElement('div');
      tmp.innerHTML = slotHtml(state.slots[si], si);
      var fresh = tmp.firstChild;
      old.parentNode.replaceChild(fresh, old);
      var np = fresh.querySelector('.kkb-pick');
      if (np) { np.scrollLeft = scroll; showPicked(np); }
      return fresh;
    }

    function renderBody() {
      var old = mount.querySelector('.kkb-tier__body');
      if (old) old.remove();
      // A product with nothing to choose (one version only) needs no rows under the bundle.
      if (!mix && P[0].opts.every(function (o) { return o.kind === 'hide'; })) return;
      var body = document.createElement('div');
      body.className = 'kkb-tier__body';
      body.innerHTML = state.slots.map(slotHtml).join('');
      tierEls[state.tier].appendChild(body);
      body.querySelectorAll('.kkb-pick').forEach(showPicked);
    }

    function missing() {
      for (var si = 0; si < state.slots.length; si++) {
        var s = state.slots[si];
        if (s.p == null) return { s: si, o: -1 };
        var p = P[s.p];
        for (var oi = 0; oi < p.opts.length; oi++) if (p.opts[oi].kind !== 'hide' && s.vals[oi] == null) return { s: si, o: oi };
      }
      return null;
    }

    function renderAtc() {
      var m = missing(), t = D.tiers[state.tier];
      if (m) {
        atc.classList.add('is-waiting');
        atc.textContent = m.o < 0 ? T.pick : T.choose.replace('{o}', P[state.slots[m.s].p].opts[m.o].name.toLowerCase());
      } else {
        atc.classList.remove('is-waiting');
        atc.innerHTML = esc(T.add) + ' <span class="kkb-atc__sep">·</span> ' + money(tierPrice(state.tier).now);
      }
    }

    function refresh() { renderPrices(); renderAtc(); }

    function selectTier(i) {
      state.tier = i;
      syncSlots();
      tierEls.forEach(function (te, k) {
        te.classList.toggle('is-on', k === i);
        te.querySelector('.kkb-tier__head').setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      msg.textContent = '';
      renderBody();
      refresh();
    }

    // Clear any choice that is no longer possible together with the others (e.g. a size sold out in the new colour).
    function tidy(slot) {
      var p = P[slot.p];
      p.opts.forEach(function (o, k) {
        if (o.kind === 'hide' || slot.vals[k] == null) return;
        if (!canPick(p, slot.vals, k, slot.vals[k])) slot.vals[k] = o.kind === 'sel' ? null : (o.values.filter(function (v) { return canPick(p, slot.vals.map(function (x, j) { return j === k ? null : x; }), k, v.name); })[0] || {}).name || null;
      });
    }

    mount.addEventListener('click', function (e) {
      var head = e.target.closest('.kkb-tier__head');
      if (head) {
        var i = Number(head.parentNode.getAttribute('data-i'));
        if (i !== state.tier) selectTier(i);
        return;
      }
      var slotEl = e.target.closest('.kkb-slot');
      if (!slotEl) return;
      var si = Number(slotEl.getAttribute('data-s'));
      var slot = state.slots[si];
      var card = e.target.closest('.kkb-card');
      if (card) {
        var pi = Number(card.getAttribute('data-p'));
        if (slot.p !== pi) { slot.p = pi; slot.vals = startVals(P[pi]); }
        msg.textContent = '';
        renderSlot(si);
        refresh();
        return;
      }
      var b = e.target.closest('.kkb-sw__b, .kkb-pill');
      if (b && !b.disabled) {
        var oi = Number(b.getAttribute('data-o'));
        slot.vals[oi] = b.getAttribute('data-v');
        tidy(slot);
        var fresh = renderSlot(si);
        refresh();
        syncGallery(slot);
        var again = fresh && fresh.querySelector('[data-o="' + oi + '"][data-v="' + CSS.escape(slot.vals[oi]) + '"]');
        if (again) again.focus({ preventScroll: true });
      }
    });

    mount.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-o]');
      if (!sel) return;
      var slotEl = sel.closest('.kkb-slot');
      var si = Number(slotEl.getAttribute('data-s'));
      var slot = state.slots[si];
      slot.vals[Number(sel.getAttribute('data-o'))] = sel.value || null;
      sel.classList.toggle('is-empty', !sel.value);
      sel.parentNode.classList.remove('is-missing');
      slotEl.querySelector('.kkb-slot__val').textContent = slotSummary(slot);
      var im = slotEl.querySelector('.kkb-slot__img');
      if (im) im.src = variantImg(P[slot.p], slot.vals);
      var ci = slotEl.querySelector('.kkb-card[aria-pressed="true"] .kkb-card__img');
      if (ci && ci.tagName === 'IMG') ci.src = variantImg(P[slot.p], slot.vals);
      if (!missing()) msg.textContent = '';
      refresh();
      syncGallery(slot);
    });

    atc.addEventListener('click', function () {
      if (atc.getAttribute('aria-busy') === 'true') return;
      var m = missing(), t = D.tiers[state.tier];
      if (m) {
        var slotEl = mount.querySelector('.kkb-slot[data-s="' + m.s + '"]');
        var label = slotLabel(m.s).toLowerCase();
        var target;
        if (m.o < 0) {
          msg.textContent = T.missingPick.replace('{s}', label);
          target = slotEl && slotEl.querySelector('.kkb-pick');
        } else {
          var oname = P[state.slots[m.s].p].opts[m.o].name.toLowerCase();
          msg.textContent = T.missing.replace('{o}', oname) + (state.slots.length > 1 ? ' ' + T.for + ' ' + label : '') + '.';
          var s = slotEl && slotEl.querySelector('select[data-o="' + m.o + '"]');
          target = s && s.parentNode;
        }
        if (target) {
          target.classList.remove('is-missing'); void target.offsetWidth; target.classList.add('is-missing');
          slotEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var f = target.querySelector('select, .kkb-card');
          if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); } }, 350);
          setTimeout(function () { target.classList.remove('is-missing'); }, 2500);
        }
        return;
      }
      var bundleId = rid(), items = [], merged = {};
      state.slots.forEach(function (s, si) {
        var v = variantOf(s);
        if (!v) return;
        var props = { _pakke: t.name || (t.qty + ' ' + D.unit) };
        if (mix && D.deal) {
          props.__kaching_bundles = JSON.stringify(si === 0
            ? { deal: D.deal, pp: D.pid, main: true, id: bundleId, bid: t.bid }
            : { id: bundleId, deal: D.deal, collectionBreaksProduct: true });
        }
        var key = v.id + '|' + (si === 0 ? 'main' : 'x');
        if (merged[key]) { merged[key].quantity++; return; }
        merged[key] = { id: v.id, quantity: 1, properties: props };
        items.push(merged[key]);
      });
      var drawer = document.querySelector('cart-drawer');
      // Use the page's normal fetch so Shopify's add-to-cart tracking (Shopify Analytics, Facebook, Triple Whale) sees bundle adds.
      // Tested 28 Oct 2026: Kaching's quantity and mix discounts apply the same way as with its raw fetch.
      var send = window.fetch;
      atc.setAttribute('aria-busy', 'true');
      msg.textContent = '';
      send.call(window, ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined, sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          atc.removeAttribute('aria-busy');
          if (!res.ok || res.j.status) { msg.textContent = res.j.description || res.j.message || T.error; return; }
          try { if (window.clarity) { window.clarity('set', 'pakke', String(t.qty)); window.clarity('event', 'kk_bundle_add'); } } catch (err) {}
          if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kk-bundle', cartData: res.j }); } catch (err) {} }
          if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: items[0] && items[0].id, sections: res.j.sections });
          } else {
            window.location.href = ROOT + 'cart';
          }
        })
        .catch(function () { atc.removeAttribute('aria-busy'); msg.textContent = T.error; });
    });

    selectTier(state.tier);
  }

  function run() { document.querySelectorAll('[data-kkb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
